var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsArticle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:twotone-newspaper"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 6.30469L15.998 7.30669L15.002 6.30469L14 7.30669L12.998 6.30469L12.002 7.30669L11 6.30469L9.998 7.30669L9.002 6.30469L8 7.30669L6.998 6.30469L6.002 7.30669L5 6.30469V15.9047C5 16.5647 5.54 17.1047 6.2 17.1047H15.8C16.46 17.1047 17 16.5647 17 15.9047V6.30469ZM10.4 15.9047H6.2V12.3047H10.4V15.9047ZM15.8 15.9047H11.6V14.7047H15.8V15.9047ZM15.8 13.5047H11.6V12.3047H15.8V13.5047ZM15.8 11.1047H6.2V9.30469H15.8V11.1047Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsArticle);
export default __webpack_public_path__ + "static/media/news-article.fe35a886c18eaa2e7c10863890f41607.svg";
export { ForwardRef as ReactComponent };